import get from "lodash/get";
import filter from "lodash/filter";
import reduce from "lodash/reduce";
import orderBy from "lodash/orderBy";

import { isApolloError } from "apollo-client/errors/ApolloError";

export function filterData(items, collection, key) {
  const selecteds = reduce(
    items,
    (obj, item) => ({ ...obj, [get(item, key)]: true }),
    {}
  );

  return filter(collection, (item) => !selecteds[item.id]);
}

export function nextPriority(values) {
  const ordered = orderBy(values, ["priority"], ["asc"]);
  if (ordered.length > 0) {
    return ordered[ordered.length - 1].priority + 1;
  }
  return 1;
}

// react-select toma un objeto vacío como opción elegida y oculta el placeholder.
export const toSelectValue = (value) =>
  value && Object.keys(value).length ? value : null;

export const onChange = (setValue) => (key) => (evt) => {
  let value = evt;
  let keyName = key || evt.target.name;

  if (evt === null || evt === undefined) {
    return setValue(keyName, null);
  }

  if (!!evt.target) value = evt.target.value;
  if (!!evt.id) value = evt.id;

  setValue(keyName, value);
};

/* eslint-disable */
export const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
/* eslint-enable */

export function formatError(error) {
  let message = error.message || "Internal Error";

  if (isApolloError(error)) {
    message = error.graphQLErrors.map((v) => `${v.message}`).join("\n");
  }

  return message;
}

export function getGraphQLErrorMessage(error, fallback = "Ocurrio un error inesperado.") {
  const message =
    error?.graphQLErrors?.[0]?.message ||
    error?.networkError?.result?.errors?.[0]?.message ||
    error?.message ||
    fallback;

  return `${message}`.replace("GraphQL error: ", "");
}

export const currencyFormat = ({ currencySymbol }) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  });

  return (amount) => currencySymbol + formatter.format(amount || 0);
};


export function onError(error, addToast) {
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    error.graphQLErrors.forEach(({ message }) => {
      addToast(message, { appearance: "error", autoDismiss: true });
    });
  } else {
    addToast(error.message, { appearance: "error", autoDismiss: true });
  }
}

// "JUAN pérez" -> "Juan Pérez". Solo para mostrar; no altera el dato guardado.
export function toTitleCase(value) {
  return String(value || "")
    .trim()
    .toLocaleLowerCase("es")
    .replace(/(^|[\s\-'])(\S)/g, (_, sep, char) => sep + char.toLocaleUpperCase("es"));
}

// "8095551234" o "809-555-1234" -> "(809) 555-1234". Otros formatos se devuelven tal cual.
export function formatPhone(value) {
  const raw = String(value || "").trim();
  const digits = raw.replace(/\D/g, "");
  const local = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (local.length !== 10) return raw;
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
}

const helpers = { onChange, validateEmail };

export default helpers;
